import React from 'react';

export default class Page5 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToDelegate');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">


                                            <ul className="greenbullet-list sept">
                                                <li><span className="brown brownbold">Delegate authority with responsibility</span> –
                                                    giving people some ‘ownership’ of the task
                                                    reduces their need to continually seek approval.
                                                </li>
                                                <li><span className="brown brownbold">Trust people</span> – they
                                                    don’t want to fail! Take care not to continually check up on
                                                    them,
                                                    unless they request this.
                                                </li>
                                                <li><span
                                                    className="brown brownbold">Be prepared for the learning curve</span> –
                                                    short-term errors can be traded for long-term
                                                    benefits and results.
                                                </li>
                                                <li><span className="brown brownbold">Check they have what is needed to complete the task</span> –
                                                    always ask, ‘What else do you
                                                    need to get started?’ or ‘Is there anything else I can help
                                                    you with?’
                                                </li>
                                                <li><span
                                                    className="brown brownbold">Praise and feedback</span> –
                                                    this is important for you and the person to whom you’ve
                                                    delegated
                                                    the task, because it’s a learning curve for both of you.
                                                    Next time, the process will be easier
                                                    for you, and he or she will better understand how you like
                                                    to work and the kind of results
                                                    you want.
                                                </li>
                                            </ul>
                                            <div className="circle_title referencepad"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>Further Information
                                            </div>
                                            <div className="uiheading"><p>If you found this tool useful then you
                                                are likely to find the following tools both insightful and
                                                relevant:</p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToMotivateOthers')}
                                                        className="link_color task button-link-redirect">How to motivate others</div>
                                                    </li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToBeAssertive')}
                                                        className="link_color task button-link-redirect">How to be assertive</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToSupportAndChallengeInTandem')}
                                                        className="link_color task button-link-redirect">How to support and challenge
                                                        in tandem</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToDevelopOthers')}
                                                        className="link_color task button-link-redirect">How to develop others</div>
                                                    </li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToWinAndManageResources')}
                                                        className="link_color task button-link-redirect">How to win and manage
                                                        resources</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToEngageOthersToDeliver')}
                                                        className="link_color task button-link-redirect">How to engage others to
                                                        deliver.</div></li>


                                                </ul>
                                            </div>
                                            <div className="circle_title referencepad"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content">Fiedler, F.
                                                    (1967). <span className="subtiltereg">A Theory of Leadership Effectiveness.</span> New
                                                    York: McGraw-Hill.</p></li>

                                                <li><p className="further_info_content">Svenson, O. (2008).
                                                    Decisions among time saving options: When intuition is
                                                    strong and wrong. <span
                                                        className="subtiltereg">Acta Psychologica,</span> 127,
                                                    501-509.</p></li>
                                                <li><p className="further_info_content">Rousseau, D.
                                                    (1996). <span className="subtiltereg">Psychological Contracts in Organisations: Understanding Written and Unwritten
Agreements.</span> Newbury Park, CA: Sage.</p></li>
                                                <li><p className="further_info_content">DuFour, R., Eaker,
                                                    R., &amp; Many, T. (2010).<span className="subtiltereg"> Learning by doing: A handbook for professional learning
communities at work.</span> Bloomington, IN: Solution Tree Press.</p></li>


                                            </ol>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page4')}
                                                     className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('Task')}
                                                    className="button-next-previous-done task">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <footer></footer>
                    </div>
                </div>
            </div>
        </div>;
    }
}